import { select,call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as domain from '../redux/ducks/domain';
import { QuoteDomain, PurchaseDomain, MapDomain } from '../server/WebServiceUrl';
import Axios from 'axios';

async function axiosQuoteDomain(domain){
  let result = {};
  try{
    result = await Axios.get(QuoteDomain,{params:{domain}});     
  }catch(e){
    if (e.response && e.response.data && e.response.data.error) {
      return e.response.data;
    }
  }
  return result;
}

async function axiosPurchase(body, domain, years, needWHOISPrivacy, paymentMethod) {
  let result = {};
  try{
    result = await Axios.post(PurchaseDomain,{contact: body, domainName: domain, years, needWHOISPrivacy, paymentMethod});     
  }catch(e){
  }
  return result;
}

async function axiosMapDomain(domainUUID, code) {
  let result = {};
  try{
    result = await Axios.post(MapDomain,{domainUUID, shopLicenseCode: code});     
  }catch(e){
    //console.log(e)
  }
  return result;
}

function * asyncQuoteDomain(arg){
  const callback = arg.payload.callback || (() => ({}));
  const domain = arg.payload.domain ;  
  let res = {};

  res = yield call( axiosQuoteDomain , domain)
  callback(res)

  // yield put({ type: domain.REQUEST_SUCCESS, payload: res});
}


function * asyncPurchase (arg) {
  const callback = arg.payload.callback || (() => ({}));
  const body = arg.payload.body ;  
  const domain = arg.payload.domain;  
  const years = arg.payload.years;  
  const paymentMethod = arg.payload.paymentMethod;
  const needWHOISPrivacy = arg.payload.needWHOISPrivacy;
  let res = {};

  res = yield call( axiosPurchase , body, domain, years, needWHOISPrivacy, paymentMethod)
  callback(res)
}

function * asyncMapKopapro (arg) {
  const callback = arg.payload.callback || (() => ({}));
  const domainUUID = arg.payload.domainUUID ;  
  const code = arg.payload.code ;  
  let res = {};

  res = yield call( axiosMapDomain , domainUUID, code)
  callback(res)
}

  
function* mySaga() {
  yield takeLatest(domain.ASYNC_DOMAIN_CHECK, asyncQuoteDomain);
  yield takeEvery(domain.ASYNC_PURCHASE, asyncPurchase);
  yield takeLatest(domain.ASYNC_MAP_KOPAPRO, asyncMapKopapro);  
}
  
export default mySaga;